import { SSMClient, SSMClientConfig } from '@aws-sdk/client-ssm';
import memoizee from 'memoizee';

export const getSSMClient = memoizee(
  (config: SSMClientConfig = {}): SSMClient => {
    return new SSMClient(config);
  },
  {
    normalizer: (args) => JSON.stringify(args[0]),
  }
);
